(() => {
  if (window.inniverseMobileWishlistReady) return;
  window.inniverseMobileWishlistReady = true;

  const mobile = window.matchMedia('(max-width: 700px)');
  const sync = () => {
    let slot = document.querySelector(mobile.matches
      ? '[data-inniverse-drawer-wishlist]'
      : '[data-inniverse-header-wishlist]');
    if (!slot && !mobile.matches) {
      const account = document.querySelector('.inniverse-home__actions > .inniverse-home__account-entry');
      if (account) {
        slot = document.createElement('div');
        slot.className = 'inniverse-home__wishlist';
        slot.setAttribute('data-inniverse-header-wishlist', '');
        account.after(slot);
      }
    }
    if (!slot) return;

    // Move the original app control so its click handlers and count stay intact.
    // Use an explicit desktop slot, not the app's possibly floating insertion point.
    document.querySelectorAll('.Vtl-WishlistHeaderWrapper').forEach((control) => {
      if (!slot.contains(control)) slot.append(control);
    });
  };

  // The wishlist app can insert or replace its control after the theme loads.
  const observer = new MutationObserver(sync);
  observer.observe(document.body, { childList: true, subtree: true });
  if (mobile.addEventListener) mobile.addEventListener('change', sync);
  else mobile.addListener(sync);
  sync();
})();
